export default {
	title: '利害关系',
	url: 'stakes',
	no_description: '未定义目标',
	context_worse: '负面',
	context_best: '正面',
	tabs: {
		filters: {
			title: '视图筛选'
		},
		general: {
			title: '常规'
		},
		export: {
			title: '导出'
		},
		comments: {
			title: '历史'
		},
		bot: {
			title: '智能'
		}
	},
	messages: {
		edit_stake: '编辑利害关系',
		create_stake: '新建利害关系'
	},
	onboarding: {
		title: '审查利害关系',
		description:
			'AI已识别出您主题的结构性利害关系。请检查它们是否真正代表了如果什么都不做您可能失去或获得的东西。根据需要调整、删除或补充。'
	}
};
